var _defs, _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-transport",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.301,
    height: 71.982,
    viewBox: "0 0 171.301 71.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    width: 171.301,
    height: 71.983,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1879",
    "data-name": "Rectangle 1879",
    width: 171.269,
    height: 71.983,
    transform: "translate(0 0)",
    fill: "#004a95"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1880",
    "data-name": "Rectangle 1880",
    width: 66.485,
    height: 71.983,
    transform: "translate(104.8 0)",
    fill: "#ffc100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_328",
    "data-name": "Groupe 328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_327",
    "data-name": "Groupe 327",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1024",
    "data-name": "Trac\\xE9 1024",
    d: "M274.1,0h-4.851s-1.947,5.626.475,10.693,3.308,12.131,2.2,14.553-4.844,1.319-3.3,10.812c1.543,9.471,5.283,14.329,3.749,16.311-1.55,1.982-7.053,3.309-5.515,8.6s3.637,10.8,5.623,11.014",
    transform: "translate(-167.66)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1025",
    "data-name": "Trac\\xE9 1025",
    d: "M229.989,7.072a7.346,7.346,0,1,0,7.344,7.343,7.346,7.346,0,0,0-7.344-7.343",
    transform: "translate(-140.026 -4.448)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1026",
    "data-name": "Trac\\xE9 1026",
    d: "M23.834,64.768h8.5v8.041h8.505V55.15H32.335c-4.706,0-8.5-2.373-8.5-5.319V34.4c0-4.384,5.743-7.971,12.754-7.971S49.34,30.015,49.34,34.4v5.814h-8.5V32.172H32.335V49.831h8.505c4.712,0,8.5,2.373,8.5,5.319V70.582c0,4.387-5.745,7.971-12.752,7.971s-12.754-3.584-12.754-7.971Z",
    transform: "translate(-14.99 -16.621)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1027",
    "data-name": "Trac\\xE9 1027",
    d: "M123.953,79.285h-.34c-3.905,0-8.161-2.366-8.161-5.1V27.592h8.5V37.783h8.5V43.1h-8.5Z",
    transform: "translate(-72.61 -17.353)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1028",
    "data-name": "Trac\\xE9 1028",
    d: "M181.183,79.285h-.347c-3.9,0-8.15-2.366-8.15-5.1V27.592h8.5V37.783h8.5V43.1h-8.5Z",
    transform: "translate(-108.606 -17.353)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1029",
    "data-name": "Trac\\xE9 1029",
    d: "M238.406,96.557h-.226c-4.026,0-8.275-2.366-8.275-5.1v-36.4h8.5Z",
    transform: "translate(-144.592 -34.625)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1030",
    "data-name": "Trac\\xE9 1030",
    d: "M361.763,33.876,320.18,82.427l3.169-.935Z",
    transform: "translate(-201.368 -21.305)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1031",
    "data-name": "Trac\\xE9 1031",
    d: "M318.3,81.851l-.722.845L321.9,81.4,360.38,33.718l-.5-.426ZM345.891,50.63c-11.28,13.995-24.287,30.111-24.367,30.217-.126.034-1.12.328-2.014.592.9-1.046,14.4-16.821,26.381-30.809",
    transform: "translate(-199.731 -20.938)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1032",
    "data-name": "Trac\\xE9 1032",
    d: "M324.983,38.4l7.751-.251,17,3.574,2.338,4.8,2.21,9.109v9.6l-3.689,7.636-4.924,5.793-5.172,2.7-8.5.5L323.378,80.5l-4.8-.984-4.188-4.8-4.431-11.454-1.228-8.005,1.228-3.937,6.4-6.893,4.558-4.687Z",
    transform: "translate(-194.165 -23.99)",
    fill: "#004a95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1033",
    "data-name": "Trac\\xE9 1033",
    d: "M321.239,54.325l.673-1.04,1.257-1.445.125-.545,1.054-.571.321-.594,1.264-.419,1.013-1.18.656-.209,1.332-.649.455.1,1.221-.377.705-.816,1.206-.147.9-.3.038-.6.943-.294.829-.021-.314.448-.7.167-.218.454.782.028,1.361-.384,1.1.036-.4.488.508.663-.419.076-.419-.558-1.382.055-1.885.5-.111.921-.839.161.063.419,1.921-.551.432-.816,1.737.1.314.188-.956.44,1.013-.013.782-.545.321.573-.545.628-.321-.007.579.886-.21.272-1.066.112-.782.07-.49-.2-1.29.007-1.042.433,1.1.076-.553.677.789-.167.119.328-1.585.887-.5-.112-1.372-.084-1.944.775.012.468-1.655,1.242-1.4,1.71-.963,1.316-1.118,1.35-.4-.1.4-.957.58-1.183-.58-.8-.317.545-.869.573-.859-.161-.488.956-.425.167.013.377.44-.171.447.144-.147.732-.356.5-.014.824-.2.272L320.82,61.6l.227.649.956-.433,1.151.538,1.612,1.242.5,1.584.4.154.684,1.4-.818,1.046.3.37,1.873.838,1.277,1.465-.411.587-.705.258-.593.586-.558,2.653-.587.537-.656-.481-.223,2.436-.895.258-.122.454.417.7-.168.363.405.2-.266.355-.579.448.271.7L321.85,77.54l-.266-1.444V74.8l-.425-.516.027-.37.321-.676-.531.349-.75-2.415-1.037-.858-.663-1.683-.028-.97.287-.768-.448-.8.147-.82.251-.275-.419-.517.129-.642.255.328.636.213.565-.269-.038-.74.786-.678-.078-.872-.14-.608.154-.956.07-.97.334-.817-.558.16.119-.4-.362-.747.223-.5.566-1.507,2.069-2.569Z",
    transform: "translate(-200.197 -28.437)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1034",
    "data-name": "Trac\\xE9 1034",
    d: "M371.043,47.511l3.064.23.446.14-.719.447.105.468-1.082,1.023-1.172-.3.386-.313-.212-.147-.189-.6.388-.363Z",
    transform: "translate(-233.357 -29.881)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1035",
    "data-name": "Trac\\xE9 1035",
    d: "M366.745,58.874l-.8.2-.014.238.4.244,1.089.112.216-.405Z",
    transform: "translate(-230.14 -37.027)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1036",
    "data-name": "Trac\\xE9 1036",
    d: "M380.986,49.919l-.969.23.8.705.838.223-.168-.845Z",
    transform: "translate(-239.001 -31.395)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1037",
    "data-name": "Trac\\xE9 1037",
    d: "M378.264,55.13l1.443.175-.4.419.445.537-.09.545.6.279.069.509-.5-.279-.633-.14-.449.37-.4-.23-.606.035.055-.308.969-.189.16-.845Z",
    transform: "translate(-237.569 -34.672)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1038",
    "data-name": "Trac\\xE9 1038",
    d: "M376.218,56.878l.132.789-1.082-.105-.237-.482.461-.129Z",
    transform: "translate(-235.865 -35.772)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1039",
    "data-name": "Trac\\xE9 1039",
    d: "M394.388,50.352l-.608.035.545.873.713-.252Z",
    transform: "translate(-247.657 -31.667)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1040",
    "data-name": "Trac\\xE9 1040",
    d: "M405.122,55.863l-.39.049.44.866.516.181Z",
    transform: "translate(-254.545 -35.134)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1041",
    "data-name": "Trac\\xE9 1041",
    d: "M390.263,73.4l-.413.188.245.161Z",
    transform: "translate(-245.185 -46.16)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1042",
    "data-name": "Trac\\xE9 1042",
    d: "M390.028,74.956l-.272.244-.034.223.424.363.245-.433Z",
    transform: "translate(-245.105 -47.142)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1043",
    "data-name": "Trac\\xE9 1043",
    d: "M391.307,78.379,391,78.54l.007.272.306.383.363-.142Z",
    transform: "translate(-245.908 -49.294)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1044",
    "data-name": "Trac\\xE9 1044",
    d: "M392.257,67.813l-.174-.838.321-1.43-.2-1.564-.5-1.7-.377-1.535-.283-1.111-.98-1.235-.4-.217.031-.446L388.47,56.3l-.763.02-1.271-.844-.021,1-1.256-.622.323-.607-.847-1.033-2.016-.963-.482-.042-.681.119-.961.733-1.1.035-.019.363.508.279.092.642h.99l.587.962.69.154.713-.615-.516-.725.648-.587.405-.1.565.509-.537.5v.586l1.479.314.195.433-.837-.165-.5.541.138-.718-.478-.091-.2,1.082-.478-.091.023-.412-2.03-.272.1-.587-.306-.391-.321.245L379.1,57.12l-2.815.105.812,1.263-.241.384-.331-.3-1.369-.265L374.088,59.9l.553.865.732.161.761-.523.616.237.8-.517.658.014.216-.524-.1-.377,2.33.719.007.866.426.355.275.3-.325.841.155.331.661-.852.295.161.166-.3-.593-.649-.107-.594.225-.628.346.216-.233.342.446.858.413.727-.092.488.329.307-.147.8.594-.258.1-.858.663.293-.355,1.011L385.9,64.8l-.2.531-.44.6.292.754-.3,2.8-.167,2.946.847.44,2.573-1.131.195-.754-.189-.746-.7-.377.088-.775,1.26.936-.067.635.025.726,1.235.163.405,1.044.692-1.033.325-1.745.4-.691Zm-6.505-5.158-1.04-.328L385.7,61.2l.7.88.537-.537.286,2.3Zm3.777,3.309-.46.685-.531-.685.4-1.828-.289-.531.243-.433.78-.014-.342,1.242.5.545Z",
    transform: "translate(-235.272 -33.466)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1045",
    "data-name": "Trac\\xE9 1045",
    d: "M368.989,75.529l-1.982-.65-.787.321-.56.084L365,75.32l-1.493.362-.638.978-1.351.509-1.3,1.815-.56,2.087-.361,1.591.99.971.3,1.507,1.522.691.934-.224,1.229-.118.388,1.606.6.223.478-.342-.786,1.082-.883,1.619.443.866-.914,2.876-1.581.753-.038,1.3-.537,1.082-.727.182.132,1-.342,1.138.168.554.921.569,1.113.084,1.659-.454,2.861-2.373,2.749-1.521.78-.924-.059-.653,1.759-2.555,1.835-.747,1.734-2.2.088-.538-1.187-.44-.606-1.409-.1-2.9-.317-.608.224-1.591-.348-.209.124-.943-2.164-1.71-.8.524-1.131-1.229-.83-.468.237-1.242Z",
    transform: "translate(-225.964 -47.093)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1046",
    "data-name": "Trac\\xE9 1046",
    d: "M387.495,129.617l-1.458.607-.237.446.118.448-.482.286-.663.879-.656.531.128.363.639-.286,1.158-1.369,1.321-1.465Z",
    transform: "translate(-241.58 -81.519)",
    fill: "#ffc100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1047",
    "data-name": "Trac\\xE9 1047",
    d: "M350.742,39.73s-15.126-6.415-29.253-2.311c0,0-9.918,6.61-12.619,14.03l-.8.1s.7,19.439,9.109,26.446c0,0,6.819,3.009,19.543,3.3,0,0,6.006-.788,6.708-1.4l3.106-2a38.993,38.993,0,0,0,9.213-14.629s2.409-12.418-5-23.536m.6,22.635c-.6,6.211-5.706,12.123-5.706,12.123a22.509,22.509,0,0,0-1.808,2.506,8.651,8.651,0,0,0-2.6.4c-2.506,1.4-12.027.5-12.027.5a20.036,20.036,0,0,0-7.112.2l-2.4-1.1c-7.615-8.92-9.115-22.845-9.115-22.845,1.8-5.709,12.822-16.026,12.822-16.026,1.8-.4,9.716.4,9.716.4,3.106-.294,16.828,3.909,16.828,3.909,2.806,2.107,1.4,19.935,1.4,19.935",
    transform: "translate(-193.75 -22.671)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1048",
    "data-name": "Trac\\xE9 1048",
    d: "M296.9,174.151H295.59v-5.27h-1.969v-.649h5.249v.649H296.9Z",
    transform: "translate(-184.665 -105.805)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1049",
    "data-name": "Trac\\xE9 1049",
    d: "M312.608,176.364H311.3v-4.613h1.305v.656l.656-.656h1.948v.656H313.6l-.991,1Z",
    transform: "translate(-195.785 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1050",
    "data-name": "Trac\\xE9 1050",
    d: "M328.756,172.406v2.331l-.935.95h-1v-3.281Zm.029,3.281v.676h1.285V171.75h-3.9l-.653.656v3.3l.653.655h1.94Z",
    transform: "translate(-204.723 -108.017)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1051",
    "data-name": "Trac\\xE9 1051",
    d: "M342.795,176.364h-1.313v-4.613h1.288v.628l.617-.628h2.028l.656.656v3.958h-1.315v-3.958H343.8l-1.005,1Z",
    transform: "translate(-214.765 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1052",
    "data-name": "Trac\\xE9 1052",
    d: "M360.549,176.364h-3.217v-.676h2.617l-2.617-2.625v-.656l.652-.656h3.25v.656h-2.59l2.59,2.6v.685Z",
    transform: "translate(-224.734 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1053",
    "data-name": "Trac\\xE9 1053",
    d: "M374.683,175.756H372.72v-3.3h1.963Zm-1.963.656h2.651l.622-.621v-3.28l-.685-.684h-3.93v5.87h1.342Z",
    transform: "translate(-233.568 -108.065)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1054",
    "data-name": "Trac\\xE9 1054",
    d: "M390.541,175.687H388.6v-3.281h1.94Zm1.346.021v-3.3l-.669-.656h-3.245l-.677.683v3.253l.677.677h3.245Z",
    transform: "translate(-243.578 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1055",
    "data-name": "Trac\\xE9 1055",
    d: "M404.5,176.364h-1.317v-4.613H404.5v.656l.644-.656H407.1v.656H405.49l-.986,1Z",
    transform: "translate(-253.573 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1056",
    "data-name": "Trac\\xE9 1056",
    d: "M420.567,174.151H418l-.686-.676v-5.242H418.6v1.305h1.992v.656h-1.954v3.281h1.933Z",
    transform: "translate(-262.459 -105.805)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1057",
    "data-name": "Trac\\xE9 1057",
    d: "M433,176.364h-3.217v-.676H432.4l-2.613-2.625v-.656l.655-.656h3.246v.656h-2.6l2.6,2.6v.685Z",
    transform: "translate(-270.303 -108.018)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1058",
    "data-name": "Trac\\xE9 1058",
    d: "M316.785,17.832h-3.9v-.684h3.3l-3.3-3.3v-1.3l.652-.641h3.913v.641h-3.281l3.281,3.288v1.333Z",
    transform: "translate(-196.78 -7.489)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1059",
    "data-name": "Trac\\xE9 1059",
    d: "M331.961,19.359h-1.938v-3.28h1.938Zm1.344.021v-3.3l-.659-.656h-3.254l-.68.691v3.245l.68.684h3.254Z",
    transform: "translate(-206.734 -9.7)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    width: 1.31,
    height: 5.923,
    transform: "translate(127.937 4.421)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1060",
    "data-name": "Trac\\xE9 1060",
    d: "M354.355,20.043h-1.911l-.681-.684V15.422h1.277v3.909h1.034l.961-.97V15.422h1.292v4.621h-1.292v-.684Z",
    transform: "translate(-221.231 -9.699)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1061",
    "data-name": "Trac\\xE9 1061",
    d: "M370.84,17.832h-2.567l-.681-.684V11.907h1.281v1.3h1.992v.657H368.9v3.28h1.936Z",
    transform: "translate(-231.187 -7.489)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1062",
    "data-name": "Trac\\xE9 1062",
    d: "M381.43,17.832h-1.305V13.211h1.305Zm0-5.284h-1.305v-.641h1.305Z",
    transform: "translate(-239.069 -7.489)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1063",
    "data-name": "Trac\\xE9 1063",
    d: "M390.279,19.359h-1.934v-3.28h1.934Zm1.346.021v-3.3l-.664-.656h-3.245l-.682.691v3.245l.682.684h3.245Z",
    transform: "translate(-243.414 -9.7)",
    fill: "#060706"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1064",
    "data-name": "Trac\\xE9 1064",
    d: "M404.407,20.043h-1.313V15.422h1.285v.636l.621-.636h2.032l.648.657v3.964h-1.311V16.079H405.4l-1,1Z",
    transform: "translate(-253.514 -9.699)",
    fill: "#060706"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStti);
export default __webpack_public_path__ + "static/media/logo-stti.143633d5702d4c86b129bfc1a58aff21.svg";
export { ForwardRef as ReactComponent };